// "use client";

// import Image from "next/image";
// import React from "react";
// import { FiCheckCircle } from "react-icons/fi";
// import { useGlobalContext } from "@/context/store";

// const page = () => {
//   const { lang } = useGlobalContext();

//   const guides = lang["guides"] || [];

//   return (
//     <div className="container mx-auto py-6 text-white my-24 px-6 xl:px-0">
//       <h2 className="text-2xl sm:text-5xl font-bold text-center mb-2">
//         {lang["STAKING"]} <span className="text-red-600">{lang["DASHBOARD"]}</span>
//       </h2>

//       <p className="text-center text-sm text-white/70 mb-6">
//         {lang["STAKING_SUBTITLE"]}
//       </p>

//       <div className="text-center mb-4">
//         <h2 className="text-xl sm:text-4xl font-bold">
//           {lang["HELP"]} & <span className="text-red-600">{lang["GUIDES_LABEL"]}</span>
//         </h2>
//         <p className="text-lg text-gray-primary mt-3 mb-6">
//           {lang["GUIDES_SUBTITLE_LINE1"]} <br />
//           {lang["GUIDES_SUBTITLE_LINE2"]}
//         </p>
//       </div>

//       <div className="flex flex-col gap-6">
//         {guides.map((guide: any, index: number) => (
//           <div
//             key={index}
//             className={`${guide.bg} rounded-xl p-6 w-full border border-white/10`}
//           >
//             <div className="flex items-center gap-2 mb-4">
//               <Image
//                 src={guide.icon}
//                 width={40}
//                 height={40}
//                 alt={`${guide.title} Icon`}
//               />
//               <h3 className={`text-xl font-semibold ${guide.color}`}>
//                 {guide.title}
//               </h3>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-12 text-sm text-white/80">
//               {guide.steps.map((step: any, idx: number) => (
//                 <div key={idx}>
//                   <div className="flex items-center gap-2 font-medium text-white">
//                     <FiCheckCircle
//                       className={`text-xs ${guide.color || "text-white/60"}`}
//                     />
//                     {step.title}
//                   </div>
//                   <p className="ml-6 text-xs text-white/50">{step.description}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default page;


"use client";
import React, { useEffect } from 'react'
import Image from 'next/image'
const page = () => {

  useEffect(() => {
    if (!sessionStorage.getItem('reloaded')) {
      sessionStorage.setItem('reloaded', 'true')
      window.location.reload()
    }
  }, [])
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: '#0a0a0a',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      color: 'white',
      textAlign: 'center',
      gap: '16px',
    }}>
<Image
        src="/images/bg.png"
        alt="Background"
        fill
        style={{ objectFit: 'cover', opacity: 0.3, zIndex: 0 }}
      />
      {/* Header */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        padding: '12px 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#111111',
        borderBottom: '1px solid #222222',
        boxSizing: 'border-box',
      }}>
        {/* Logo + Brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Image
            src="/images/logo.png"
            alt="BlackChain Logo"
            width={60}
            height={60}
          />
          <span style={{ fontSize: '1.6rem', fontWeight: 'bold' }}>
            Black<span style={{ color: '#ff3333' }}>Chain</span>
          </span>
        </div>

        {/* Right side buttons */}
        
      </div>

      {/* Maintenance Icons */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        marginBottom: '8px',
      }}>
        <span style={{ fontSize: '5rem', animation: 'spin 4s linear infinite' }}>⚙️</span>
        <span style={{ fontSize: '6rem' }}>🔧</span>
        <span style={{ fontSize: '5rem', animation: 'spin 4s linear infinite reverse' }}>⚙️</span>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>

      {/* Centered content */}
      <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#ff3333' }}>
        🔧 Wartungsmodus 🔧
      </h1>
      <p style={{ fontSize: '1.2rem', color: '#cccccc' }}>
        Wir arbeiten gerade am Staking. Geben Sie uns etwas Zeit.
      </p>
    </div>
  )
}

export default page